import Vue from 'vue';
import App from './App.vue';
import router from './router';

import VueResource from 'vue-resource';

import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css'; // import style
import '@/static/commonStyle.css';
Vue.use(ViewUI);

Vue.config.productionTip = false;
Vue.use(VueResource); // 使用VueResource

// 所有业务请求统一携带服务端签发的身份令牌；页面保存的用户资料不能作为权限依据。
Vue.http.interceptors.push((request, next) => {
  const token = sessionStorage.getItem('AC_ACCESS_TOKEN');
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`);
  }

  next(response => {
    if (response.status === 401) {
      sessionStorage.removeItem('AC_ACCESS_TOKEN');
      localStorage.removeItem('AC_USER_INFO');
      if (router.currentRoute.path !== '/login') {
        router.replace('/login');
      }
    }
    return response;
  });
});

import xLayout from './components/xLayout.vue'; // 把头部组件挂载到全局
Vue.component('X-Layout', xLayout); // 把头部组件挂载到全局

// 按需引入 ElementUI 部分组件
import { Tree } from 'element-ui';
Vue.component(Tree.name, Tree);

// 通过环境变量获取接口
// let _dev_api = 'http://192.168.0.57:8890/Environmental/';
let _dev_api = 'https://api.wxnwst.com/Environmental/';

Vue.prototype.ApiUrl = process.env.NODE_ENV == 'development' ? _dev_api : 'https://api.wxnwst.com/Environmental/';

// 时间转换
Vue.prototype.formatDateTime1 = function (inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  return y + '-' + m + '-' + d;
};
Vue.prototype.formatDateTime = function (inputTime) {
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? '0' + minute : minute;
  second = second < 10 ? '0' + second : second;
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};
new Vue({
  router,
  // store,
  render: h => h(App),
}).$mount('#app');
